import {installDisplayFit} from '../../i18n/display-fit';
import '../../styles/activity-language.css';
import React,{useEffect} from 'react';
import {I18nextProvider} from 'react-i18next';
import i18next from '../../i18n/config';
import {normalizeLanguage} from '../../i18n/languages';
import '../../styles/localized-layout.css';
export default function Language({children}){
 useEffect(()=>installDisplayFit(),[]);
 useEffect(()=>{
  const reflect=value=>{document.documentElement.lang=normalizeLanguage(value);};
  // Native/other-tab storage events must not replace the active SDK choice.
  reflect(i18next.language);i18next.on('languageChanged',reflect);
  return ()=>{i18next.off('languageChanged',reflect);};
 },[]);
 // Never key/remount payment components when the locale changes.
 return <I18nextProvider i18n={i18next}>{children}</I18nextProvider>;
}
